import { CssBaseline } from '@material-ui/core';
import { StylesProvider } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { ConnectedRouter } from 'connected-react-router';
import * as React from 'react';
import { useMemo } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { MUIAppTheme } from '~/styles';
import { AppRouter } from './router';
import { browserHistory, persistor, store } from './store';
import './styles/index.scss';

import { Loader } from '~/common/loader';

const StoreContext: React.FC = ({ children }) => {
    const PersistLoader = useMemo(() => {
        return <Loader />;
    }, []);

    return (
        <Provider store={store}>
            <PersistGate loading={PersistLoader} persistor={persistor}>
                {children}
            </PersistGate>
        </Provider>
    );
};

const ThemeContext: React.FC = ({ children }) => {
    return (
        <ThemeProvider theme={MUIAppTheme}>
            <StylesProvider injectFirst>
                <CssBaseline />
                {children}
            </StylesProvider>
        </ThemeProvider>
    );
};

const Contexts: React.FC = ({ children }) => {
    return (
        <StoreContext>
            <ThemeContext>
                <ConnectedRouter history={browserHistory}>{children}</ConnectedRouter>
            </ThemeContext>
        </StoreContext>
    );
};

export const App: React.FC = () => {
    return (
        <Contexts>
            <AppRouter />
        </Contexts>
    );
};
